module.exports = __webpack_public_path__ + "static/media/Port.36d331c5.png";